import data from './data'
import datalocation from './data-location'
import './index.scss'

const cityData = Object.values(data).sort((a,b)=>a.index > b.index ? 1: -1)
const quickLocation = Array.from(new Set(cityData.map(i => i.index)))
const cityHash = cityData.reduce((t,c) => {
  for(let i of c.cities){
    t[i.adcode] = i.name
  }
  if(c.cities.length == 0) t[c.adcode] = c.name
  return t
},{})

export const getPositionByCode = (code) => {
  return code == '86' ? [108.948024, 34.263161] : datalocation[code]
}

export default {
  name:'CitySelect',
  props:['value'],
  data(){
    return {
      visible:false,
      currentChecked:[]
    }
  },
  created(){
    this.$watch('value' , function(nv){
      if(nv && Array.isArray(nv)) this.currentChecked = nv
      else this.currentChecked = []
    },{immediate:true})
  },
  methods:{
    renderCity(i){
      let cities = i.cities.length == 0 ? [i] : i.cities
      const { currentChecked } = this
      return cities.map(i => (
        <a on-click={() => this.handleSelect(i)} class={{'hd-item':1 , 'checked': currentChecked.includes(i.adcode)}}>{i.name}</a>
      ))
    },
    renderQuick(i){
      return quickLocation.map(i => (
        <a on-click={()=>{this.handleQuickLocation(i)}}>{i}</a>
      ))
    },
    handleClick(){
      this.visible = true
    },
    handleOutSide(){
      this.visible = false
    },
    handleQuickLocation(i){
      let top = this.$el.querySelector(`[tag="${i}"]`).offsetTop
      this.$refs.content.scrollTop = top
      // this.$el.querySelector(`[tag="${i}"]`).focus()
    },
    handleSelect(data){
      const { currentChecked } = this
      let key = data.adcode
      let idx = currentChecked.findIndex(i => i == key)
      if(idx >= 0){
        currentChecked.splice(idx , 1)
      }else{
        currentChecked.push( key )
      }

      this.currentChecked = currentChecked

      this.$emit('change' , this.currentChecked)
      // this.currentChecked.push( )
    },
    handleRemove(i,e){
      this.handleSelect({adcode:i})
      e.stopPropagation()
    },
    renderResult(){
      return this.currentChecked.map(i => (
        <div class="result-item"><span>{cityHash[i]}</span><span class="sl-city-select-remove" on-click={e => this.handleRemove(i , e)}>x</span></div>
      ))
    }
  },
  render(){
    return (
      <div v-click-outside={this.handleOutSide} class={{"sl-city-select":1 , 'visible':this.visible}}>
        <div class="sl-city-select-result" on-click={this.handleClick}>
          { this.renderResult() }
        </div>
        <div class="sl-city-select-drop">
          <div class="sl-city-select-loc">
            {this.renderQuick()}
          </div>
          <div class="sl-city-select-content" ref="content">
            {
              cityData.map(i => (
                <div class="item" tag={i.index} >
                  <div class="hd">{i.name}</div>
                  <div class="bd">{this.renderCity(i)}</div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    )
  }
}